import { fontSizeToPixelMap } from '../theme/foundation/typography/font-size';
export const backgroundToTokens = (bg)=>({
        bg: bg && bg !== 'transparent' ? `${bg === 'pink' ? 'fill.new' : `background.${bg}`}` : 'transparent',
        color: [
            'white',
            'pink',
            'light'
        ].includes(bg) ? 'text.primary' : 'text.inverse'
    });
export const remForSize = (size)=>`${fontSizeToPixelMap[size] / 16}rem`;
// Round to 4 (10_000) decimal places
const round = (num)=>Math.round((num + Number.EPSILON) * 10000) / 10000;
// Line height on all Design System typography sizes is 140%
export const lineHeightForSize = (size)=>`${round(1.4 * fontSizeToPixelMap[size] / 16)}rem`;

//# sourceMappingURL=index.js.map